import { SET_NAV_ITEMS } from './actionType'

export function setNavItems(navItems) {
  return {
    type: SET_NAV_ITEMS,
    navItems: navItems,
  }
}
